export const createStyles = (theme?: any) => {
  const isDark = theme?.palette?.mode === 'dark';
  return {
    wrapper: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 0,
      width: '100%',
      minWidth: 0,
      fontFamily: theme?.typography?.fontFamily,
      minHeight: '100%',
      padding: { xs: 0, md: '2.5rem 1.5rem' },
    },
    submissionsSection: {
      display: 'flex',
      flexDirection: 'column',
      gap: '18px',
      mt: '30px',
      maxWidth: '792px',
      minWidth: 0,
      width: '100%',
    },
    submissionsTitle: {
      color: 'text.primary',
      fontFamily: theme?.typography?.fontFamily,
      fontSize: '1.25rem',
      fontWeight: theme?.typography?.fontWeightMedium ?? 500,
      fontStyle: 'normal',
      letterSpacing: '0.15px',
      lineHeight: '160%',
      m: 0,
    },
    emptyWrapper: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      height: '100%',
      width: '100%',
      minWidth: 0,
      fontFamily: theme?.typography?.fontFamily,
    },
    noResultsCard: {
      width: '100%',
      flex: 1,
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '4px',
      borderRadius: theme?.shape?.borderRadius ?? 2,
      bgcolor: isDark ? '#231F29' : '#F8F7F9',
      pt: { xs: '12px', sm: '12px', md: '16px' },
      px: { xs: '16px', sm: '16px', md: '16px' },
      pb: { xs: '12px', sm: '12px', md: '16px' },
      boxSizing: 'border-box',
    },
    noResultsCardTitle: {
      fontFamily: theme?.typography?.fontFamily,
      fontWeight: theme?.typography?.fontWeightRegular ?? 400,
      fontSize: '1rem',
      lineHeight: '175%',
      letterSpacing: '0.15px',
      color: 'text.primary',
      textAlign: 'center',
      mt: '-0.25rem',
    },
    contentBox: {
      width: { xs: '100%', lg: '792px' },
      maxWidth: { xs: '100%', md: '792px' },
    },
    noResultsCardDescription: {
      fontFamily: theme?.typography?.fontFamily,
      fontWeight: theme?.typography?.fontWeightRegular ?? 400,
      fontSize: '0.875rem',
      lineHeight: '143%',
      letterSpacing: '0.17px',
      textAlign: 'center',
      color: 'text.secondary',
      whiteSpace: 'pre-line',
    },
  };
};
